import type { Workflow } from '@takeshape/schema';
import { createRoutine } from 'app/common/utils/new-routines';
import { type ActionType, createAction } from 'typesafe-actions';

export type SaveWorkflowResponse = {
  workflow: Workflow;
  schemaVersion: number;
};

export type RemoveWorkflowResponse = {
  name: string;
  schemaVersion: number;
  removed: boolean;
};

export const saveWorkflowRoutine = createRoutine('workflows/SAVE_WORKFLOW')<
  undefined,
  Workflow,
  undefined,
  SaveWorkflowResponse,
  string,
  undefined
>();
export type SaveWorkflowRoutineActionType = ActionType<typeof saveWorkflowRoutine>;

export const updateWorkflowRoutine = createRoutine('workflows/UPDATE_WORKFLOW')<
  undefined,
  Workflow,
  undefined,
  SaveWorkflowResponse,
  string,
  undefined
>();
export type UpdateWorkflowRoutineActionType = ActionType<typeof updateWorkflowRoutine>;

export const removeWorkflowRoutine = createRoutine('workflows/REMOVE_WORKFLOW')<
  undefined,
  string | Set<string>,
  undefined,
  RemoveWorkflowResponse,
  string,
  undefined
>();
export type RemoveWorkflowRoutineActionType = ActionType<typeof removeWorkflowRoutine>;

export const initWorkflowsMultiSelect = createAction('workflows/INIT_MULTI_SELECT')();
